import React, { useState } from 'react';
import { arrayOf, bool, func, number, oneOfType, shape, string } from 'prop-types';
import compose from 'recompose/compose';
import clsx from 'clsx';

import {
  withStyles,
  Grid,
  Button,
  Tooltip,
  Typography,
  IconButton,
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';

import {
  AlertMessages,
  Footer,
  Loading,
  Table,
  TablePagination,
} from '../components';
import styles from './list.styles';
import { GRID_ROWS_PER_PAGE_OPTIONS } from '../constants';

export const List = (props) => {
  const {
    classes,
    userContext,
    listPageId,
    isLoading,
    notificationId,
    notificationStatus,
    setNotificationStatus,
    notificationMessage,
    setNotificationMessage,
    onCloseNotification,
    pageHeaderTitle,
    pageHeaderTooltipTitle,
    addButtonLabel,
    onAdd,
    disableAdd,
    filterAndSortContent,
    columns,
    noResultsMessage,
    page,
    totalElements,
    totalPages,
    rowsPerPage,
    onChangeRowsPerPage,
    onChangePage,
    onChangePreviousPage,
    onChangeNextPage,
    showListHeader = true,
    pageClass = null,
    pageBodyClass,
    pageFilterAndSortClass,
    uuidName = null,
    notifyMessages,
  } = props;

  const [expandedRows, setExpandedRows] = useState([]);

  const rows = props.rows.map(
    row => ({
      ...row,
      expanded: expandedRows.includes(row.uuid),
      onClick: (uuid) => {
        if (expandedRows.includes(uuid)) {
          setExpandedRows(expandedRows.filter(e => (e !== uuid)));
        } else {
          setExpandedRows([...expandedRows, uuid]);
        }
      },
    }),
  );

  const notificationMessages = (status, message) => {
    setNotificationStatus(status);
    setNotificationMessage(message);
  };

  return (
    <Grid
      className={clsx(pageClass, classes.page)}
      id={listPageId} data-apim-test={listPageId} data-layer7-test={listPageId}
    >
      {notificationMessage &&
        <AlertMessages
          className={classes.alertMessages}
          id={notificationId}
          variant={notificationStatus}
          message={notificationMessage}
          onClose={() => {
            notificationMessages('', '');
            if (onCloseNotification) { onCloseNotification(); }
          }}
        />
      }
      {isLoading ?
        <Loading pageLoader />
        :
        <div className={clsx(pageBodyClass, classes.pageBody)}>
          {showListHeader &&
            <Grid container justify="space-between" className={classes.pageHeader}>
              <Grid item md={10} sm={9} xs={12}>
                <Grid container>
                  <Grid item>
                    <Typography
                      variant="h1"
                      className={classes.pageTitle}
                      id={`${listPageId}-title`} data-apim-test={`${listPageId}-title`} data-layer7-test={`${listPageId}-title`}
                    >
                      {pageHeaderTitle}
                    </Typography>
                  </Grid>
                  {pageHeaderTooltipTitle &&
                    <Tooltip
                      arrow disableFocusListener disableTouchListener placement="top"
                      title={pageHeaderTooltipTitle}
                    >
                      <IconButton
                        size="small" edge="start" color="secondary"
                        className={classes.helpIcon}
                        id={`${listPageId}-help`} data-apim-test={`${listPageId}-help`} data-layer7-test={`${listPageId}-help`}
                        aria-label="gateway-bundle-help"
                      >
                        <HelpIcon />
                      </IconButton>
                    </Tooltip>
                  }
                </Grid>
              </Grid>
              <Grid
                item md={2} sm={3} xs={12}
                className={classes.addBundleButton}
              >
                {onAdd &&
                  <Button
                    variant="contained" color="secondary"
                    onClick={onAdd || (() => {})}
                    id={`${listPageId}-add`} data-apim-test={`${listPageId}-add`} data-layer7-test={`${listPageId}-add`}
                    disabled={disableAdd}
                  >
                    {addButtonLabel}
                  </Button>
                }
              </Grid>
            </Grid>
          }
          <Grid
            container justify="space-between"
            className={clsx(pageFilterAndSortClass, classes.pageFilterAndSort)}
          >
            {filterAndSortContent}
          </Grid>
          <Table
            userContext={userContext}
            id={`${listPageId}-list`}
            columns={columns}
            rows={rows}
            noResultsMessage={noResultsMessage}
            uuidName={uuidName}
            notifyMessages={notifyMessages}
          />
          <TablePagination
            id={`${listPageId}-pagination`}
            page={page}
            count={totalElements}
            pageCount={totalPages}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={GRID_ROWS_PER_PAGE_OPTIONS}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onChangePage={onChangePage}
            onChangePreviousPage={onChangePreviousPage}
            onChangeNextPage={onChangeNextPage}
          />
        </div>
      }
      <Footer />
    </Grid>
  );
};

List.propTypes = {
  classes: shape({}),
  userContext: shape({}),
  listPageId: string,
  isLoading: bool,
  notificationId: string,
  notificationStatus: string,
  setNotificationStatus: func,
  notificationMessage: string,
  setNotificationMessage: func,
  onCloseNotification: func,
  pageHeaderTitle: string,
  pageHeaderTooltipTitle: string,
  addButtonLabel: string,
  onAdd: oneOfType([func, bool]),
  disableAdd: bool,
  filterAndSortContent: shape({}),
  columns: arrayOf(shape({})),
  rows: arrayOf(shape({})),
  noResultsMessage: string,
  page: number,
  totalPages: number,
  totalElements: number,
  rowsPerPage: number,
  onChangeRowsPerPage: func,
  onChangePage: func,
  onChangePreviousPage: func,
  onChangeNextPage: func,
  showListHeader: bool,
  pageClass: string,
  pageBodyClass: string,
  pageFilterAndSortClass: string,
};

export default compose(
  withStyles(styles),
)(List);



// WEBPACK FOOTER //
// ./src/pages/list.js